import { InjectionToken } from '@angular/core';

// https://stackoverflow.com/a/54362206

export const WindowToken = new InjectionToken<Window>('Window');

export function windowProvider() {
  return window;
}
